<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>OFERTAS DE LICITACIÓN</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/familias']" class="nav-link m-1 pl-3 pr-3">Familias</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/calificacion']" class="nav-link m-1 pl-3 pr-3 ">Calificación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/ofertas-de-licitacion']" class="nav-link m-1 pl-3 pr-3 " tabindex="-1" aria-disabled="true"> Ofertas de Licitación</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/postulantes-ofertas']" class="nav-link m-1 pl-3 pr-3 disabled" tabindex="-1" aria-disabled="true"> Postulantes por oferta</a>
                    </li>
                    <!-- <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/consultas-reportes']" class="nav-link m-1 pl-3 pr-3 "> Consultas/Reportes </a>
                    </li> -->
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/administrador/login']" class="nav-link cerrar m-1 pl-3 pr-3 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row pb-5 mt-5">
            <div class="col-12 mb-1">
                <div class="row FlstLi mb-2">
                   <div class="col-6 col-md-6 col-lg-3 text-left my-2 ">
                        <button type="submit" class="mr-2" (click)="gopro()" *ngIf="this.provedore"> Regresar </button>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mx-auto">
                <div class="FlstLi table-responsive">
                    <div class="row dDoce text-right pr-2 barIcon">
                        <div class="col-8 col-sm-8 col-md-3 col-lg-2 ml-auto barIconInt">
                            <div class="row dDoce mx-0">
                                <!-- <div class="col-12 ml-auto px-0">
                                    <a href="#" data-type="excel">
                                        <img class="ico-formulario iconClick" src="./../../../../../assets/images/icons/icono-descarga.svg" alt="Descarga">
                                    </a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <table class="Ftabla Ftablon table dDoce" *ngIf="this.principal">
                        <tr>
                            <th scope="col" class="pl-2 pr-2">Código</th>
                            <th scope="col" class="pl-2 pr-2">Producto</th>
                            <th scope="col" class="pl-2 pr-2">Fecha de publicación</th>
                            <th scope="col" class="pl-2 pr-2">Familia</th>
                            <th scope="col" class="pl-2 pr-2">Activo</th>
                        </tr>
                        <tr></tr>
                        <tbody class="tablaBlq" *ngFor="let oferta of ofertas| paginate: { itemsPerPage: 4, currentPage: p }">
                            <tr>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.codigo}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.producto}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.fechaPublicacion | date: 'dd-MM-yyyy hh:mm'}}</td>
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.familia}}</td>          
                                <td class="pl-2 pr-2 align-middle" (click)="change(oferta)">{{oferta.activo ? 'Si' : 'No'}}</td>
                            </tr>
                            <tr></tr>
                        </tbody>
                        <pagination-controls previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="p = $event"></pagination-controls>
                    </table>
                    <table class="Ftabla Ftablon table dDoce" *ngIf="this.provedore">
                        <tr>
                            <th scope="col" class="pl-2 pr-2">RFC</th>
                            <th scope="col" class="pl-2 pr-2">Razon Social</th>
                            <th scope="col" class="pl-2 pr-2">Correo</th>
                            <th scope="col" class="pl-2 pr-2">Calificacion</th>
                            <th scope="col" class="pl-2 pr-2">Detalles</th>
                        </tr>
                        <tr></tr>
                        <tbody class="tablaBlq" *ngFor="let provedor of proveedorList| paginate: { itemsPerPage: 4, currentPage: p }">
                            <tr class="detallesprovedor">
                                <td class="pl-2 pr-2 align-middle">{{provedor.rfc}}</td>
                                <td class="pl-2 pr-2 align-middle">{{provedor.razonSocial}}</td>
                                <td class="pl-2 pr-2 align-middle">{{provedor.correo}}</td>      
                                <td class="pl-2 pr-2 align-middle">{{provedor.calificacion}}</td>      
                                <button type="submit" class="mr-2" (click)="detalle(provedor)"> Detalle </button>
                            </tr>
                            <tr></tr>
                        </tbody>
                        <pagination-controls previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="p = $event"></pagination-controls>
                    </table>

                    <div class="row">
                        <div class="col-10 mx-auto">
                            <form #f="ngForm" ngNativeValidate  class="pb-3 row"  *ngIf="this.dataprovedor">
                                <div class="form-row">
                                    <div class="form-group col-6 text-left">
                                        <label for="rfcescrito">RFC</label>
                                        <input [(ngModel)]="rfcescrito" name="rfcescrito" type="text" class="form-control" id="rfcescrito" pattern="^[a-zA-Z]{3,4}[0-9]{6}[A-Za-z0-9]{2,3}"minlength="12" maxlength="13" required>
                                    </div>
                                    <div class="form-group col-6 text-left ">
                                        <label for="razonSocial">Razón social</label>
                                        <input [(ngModel)]="razonSocial" name="razonSocial" type="text" class="form-control">
                                    </div>
                                    <div class="form-group col-6 text-left">
                                        <label for="calle">Calle</label>
                                        <input [(ngModel)]="calle" name="calle" type="text" class="form-control">
                                    </div>
                                    <div class="form-group col-lg-3 col-md-3 col-6 text-left">
                                        <label for="nInterior">N. Interior</label>
                                        <input [(ngModel)]="nInterior" name="nInterior" type="text" class="form-control" id="nInterior">
                                    </div>
                                    <div class="form-grou col-lg-3 col-md-3 col-6 text-left">
                                        <label for="nExterior">N. Exterior</label>
                                        <input [(ngModel)]="nExterior" name="nExterior" type="text" class="form-control" id="nExterior">
                                    </div>
                                    <div class="form-group col-6 text-left">
                                        <label for="colonia">Colonia</label>
                                        <input [(ngModel)]="colonia" name="colonia" type="text" class="form-control" id="colonia">
                                    </div>
                                    <div class="form-group col-6 text-left">
                                        <label for="referencia">Referencia</label>
                                        <input [(ngModel)]="referencia" name="referencia" type="text" class="form-control" id="referencia">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="correo">Estado</label>
                                        <select  [(ngModel)]="idestado" name="idestado" class="form-control" (ngModelChange)="getCiudades($event)" required>
                                            <option [ngValue]="" selected>Seleccione Estado</option>
                                            <option *ngFor="let estado of estados" [ngValue]="estado.idestado"> {{ estado.nombre | uppercase}} </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="correo">Municipio</label>
                                        <select [(ngModel)]="idMunicipio" name="idMunicipio" class="form-control">
                                            <option *ngFor="let ciudad of ciudades" [ngValue]="ciudad.idMunicipio"> {{ ciudad.nombre | uppercase}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="cp">Código Postal</label>
                                        <input [(ngModel)]="cp" name="cp" type="text" class="form-control" id="cp" pattern="[0-9]{5}" >
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="giro">Giro de la empresa</label>
                                        <input [(ngModel)]="giro" name="giro" type="text" class="form-control" id="giro">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="nombreContacto">Nombre del contacto</label>
                                        <input [(ngModel)]="nombreContacto" name="nombreContacto" type="text" class="form-control" id="nombreContacto">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="apellidoPaterno">Apellido paterno</label>
                                        <input [(ngModel)]="apellidoPaterno" name="apellidoPaterno" type="text" class="form-control" id="apellidoPaterno">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="apellidoMaterno">Apellido materno</label>
                                        <input [(ngModel)]="apellidoMaterno" name="apellidoMaterno" type="text" class="form-control" id="apellidoMaterno">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="telefonoFijo">Teléfono fijo</label>
                                        <input [(ngModel)]="telefonoFijo" name="telefonoFijo" type="tel" class="form-control" id="telefonoFijo" pattern="[0-9]{10}" maxlength="10">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                                        <label for="telefonoMovil">Teléfono móvil</label>
                                        <input [(ngModel)]="telefonoMovil" name="telefonoMovil" type="tel" class="form-control" id="telefonoMovil" pattern="[0-9]{10}" maxlength="10">
                                    </div>
                                    <div class="form-group col-lg-8 text-left">
                                        <label for="email">Correo electrónico</label>
                                        <input [(ngModel)]="email" name="email" type="email" class="form-control" id="email">
                                    </div>
                                </div>
                
                                <div class="row upload pb-1" style="width: 100%;">
                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="cvEmpresarial">CV empresarial</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlcvEmpresarial}}" target="_blank">Ver</a>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="domicilioFiscal">Comprobante de domicilio fiscal</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urldomicilio}}" target="_blank">Ver</a>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="situacionFiscal">Comprobante de situación fiscal</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlsituacionFiscal}}" target="_blank">Ver</a>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="estadoCuenta">Estado de cuenta</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlestadoCuenta}}" target="_blank">Ver</a>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="rfc">RFC</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlRFC}}" target="_blank">Ver</a>
                                    </div>
                
                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="ine">INE (Representante legal)</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlIne}}" target="_blank">Ver</a>
                                    </div>
                
                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="imss">Evaluación del IMSS</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlImss}}" target="_blank">Ver</a>
                                    </div>

                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="imss">Evaluación del IMSS</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlImss}}" target="_blank">Ver</a>
                                    </div>

                                    <div class="form-group col-lg-4 col-md-6">
                                        <label for="opinioncumpli">Opinión de Cumplimiento</label>
                                        <br>
                                        <a href="https://fundacionbest.org.mx/WebApi/{{urlOpinion}}" target="_blank">Ver</a>
                                    </div>
                                </div>
                                <button  (click)="evaluar()" class="btn-enviar px-5">Evaluar</button>
                            </form>
                        </div>
                    </div>
                    
                </div>
                <!-- <pagination-controls previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="p = $event"></pagination-controls> -->
            </div>
        </div>
      
        <div class="col-12 alerta-big blqCtr text-center" *ngIf="this.editar">
            <div class="row mb-2">
                <h4>Actualiza Oferta</h4>
            </div>
            <form  ngNativeValidate #Update="ngForm" (ngSubmit)="UpdateCalifo(Update)"  class="pb-3 row">
                <div class="row">

                    <div class="form-group col-12 col-md-12 col-lg-9 text-left">
                        <label for="razonSocial" class="pt-2">Proveedor</label>
                        <input [(ngModel)]="razonSocial" name="razonSocial" type="text" id="razonSocial" maxlength="50" value="" readonly class="form-control">
                    </div>
                    <div class="form-group col-12 col-md-12 col-lg-9 text-left">
                        <label for="productoUpdate" class="pt-2">Producto</label>
                        <input [(ngModel)]="productoUpdate" name="productoUpdate" type="text" id="productoUpdate" maxlength="50" value="" readonly class="form-control">
                    </div>
                    <div class="form-group col-12 col-md-12 col-lg-4 text-left">
                        <label for="rfcescrito" class="pt-2">RFC</label>
                        <input [(ngModel)]="rfcescrito" name="rfcescrito" type="text" id="rfcescrito" maxlength="50" value="" readonly class="form-control">
                    </div>
                    <div class="form-group col-12 col-md-4 col-lg-4 text-left">
                        <label>familia</label>
                        <input [(ngModel)]="familiaUpdate " name="familiaUpdate " type="text" id="familiaUpdate " maxlength="50" value="" readonly class="form-control">
                    </div>
                    <div class="form-group col-lg-4 col-md-6 col-6 text-left">
                        <label for="calificacionUpdate">Calificación</label>
                        <select ngModel="calificacionUpdate" name="calificacionUpdate" class="form-control" (ngModelChange)="getcommentario($event)">
                            <option [ngValue]="" selected>Seleccione Calificacion</option>
                            <option *ngFor="let calificacion of calificaciones" [ngValue]="calificacion.id"> {{ calificacion.calificacion}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 text-left" *ngIf="this.showcomm">
                        <label for="mensajeTextArea">Mensaje</label>
                        <textarea
                            ngModel
                            name="comentarios"
                            name="comentarios"
                            class="form-control"
                            placeholder="Comentario"
                            rows="6"
                            style="border: solid 1px; border-color: #cadce6; background-color: #FFFFFF; border-radius: 6px; resize: none;"
                            required
                        ></textarea>
                    </div>
                  
                    <div class="col-12">
                        <button type="submit" class="mr-2"> Actualizar </button>
                        <button class="ml-2 redBtn" (click)="cancel()"> Cancelar</button>
                    </div>
                </div>
            </form>
        </div>

     
        <div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-formulario" src="./../../../../assets/images/icons/icono-warning.png">
            <p>¿La información que ingreso es correcta?</p>
            <button class="btn-confirmar mr-2" (click)="closeok()">Aceptar</button>
            <button class="ml-2 redBtn" (click)="closefail()"> Cancelar</button>
        </div>

	</div>

</div>